import gql from "../gql.js"
import { query, mutation } from "./queries.js"
import errorsFactory from "../errorsFactory.js"
import handleErrors from "../handleErrors.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async initialize(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.initializePolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.initializePolicy) {
			if (res.data.initializePolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.initializePolicy.errors })
		} else return handleErrors(res)
	},

	async issue(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.issuePolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.issuePolicy) {
			if (res.data.issuePolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.issuePolicy.errors })
		} else return handleErrors(res)
	},

	async addBeneficiaryEligibility(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.addBeneficiaryEligibility,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.addBeneficiaryEligibility) {
			if (res.data.addBeneficiaryEligibility.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.addBeneficiaryEligibility.errors
				})
		} else return handleErrors(res)
	},

	async commissionSummary(variables) {
		let res = null

		try {
			res = await gql({
				query: query.commissionSummary(),
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.policies && res.data.policies.list) {
			if (!res.data.policies.list[0])
				return Promise.resolve(errorsFactory({ code: "policy_doesnt_exist" }))
			else return Promise.resolve({ data: res.data })
		}
		return handleErrors(res)
	},

	async commissionSplitAndSummary(variables) {
		let res = null

		try {
			res = await gql({
				query: query.commissionSplitAndSummary(),
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.policies && res.data.policies.list) {
			if (!res.data.policies.list[0])
				return Promise.resolve(errorsFactory({ code: "policy_doesnt_exist" }))
			else return Promise.resolve({ data: res.data })
		}
		return handleErrors(res)
	},

	async addCommissionRuleToPolicy(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.addCommissionRuleToPolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.addCommissionRuleToPolicy) {
			if (res.data.addCommissionRuleToPolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.addCommissionRuleToPolicy.errors
				})
		} else return handleErrors(res)
	},

	async addCommissionRuleToPolicy(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.addCommissionRuleToPolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.addCommissionRuleToPolicy) {
			if (res.data.addCommissionRuleToPolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.addCommissionRuleToPolicy.errors
				})
		} else return handleErrors(res)
	},

	async removeCommissionRuleFromPolicy(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.removeCommissionRuleFromPolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.removeCommissionRuleFromPolicy) {
			if (res.data.removeCommissionRuleFromPolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.removeCommissionRuleFromPolicy.errors
				})
		} else return handleErrors(res)
	},

	async updatePolicyCommissionRule(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.updatePolicyCommissionRule,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.updatePolicyCommissionRule) {
			if (res.data.updatePolicyCommissionRule.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.updatePolicyCommissionRule.errors
				})
		} else return handleErrors(res)
	},

	async placeTravelOrder(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.placeTravelOrder,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.createPolicy) {
			if (res.data.createPolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.createPolicy.errors })
		} else return handleErrors(res)
	},

	async update(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.update,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.updatePolicy) {
			if (res.data.updatePolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.updatePolicy.errors })
		} else return handleErrors(res)
	},

	async updateContractInsuredPerson(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.updateContractInsuredPerson,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.updateContractInsured) {
			if (res.data.updateContractInsured.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.updateContractInsured.errors
				})
		}
		return handleErrors(res)
	},

	async readAll(variables) {
		let res = null

		try {
			res = await gql({
				query: query.readAll(),
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.policies && res.data.policies.list)
			return Promise.resolve({ data: res.data })
		else return handleErrors(res)
	},

	async readOne(variables) {
		let res = null

		try {
			res = await gql({
				query: query.readOne(),
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.policies && res.data.policies.list) {
			if (!res.data.policies.list[0])
				return Promise.resolve(errorsFactory({ code: "policy_doesnt_exist" }))
			else return Promise.resolve({ data: res.data })
		}
		return handleErrors(res)
	},

	async deleteFile(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.deleteFile,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.removePolicyAttachment) {
			if (res.data.removePolicyAttachment.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.removePolicyAttachment.errors
				})
		}
		return handleErrors(res)
	},

	async addNote(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.addNote,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.addPolicyNote) {
			if (res.data.addPolicyNote.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.addPolicyNote.errors })
		}
		return handleErrors(res)
	},

	async updateNote(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.updateNote,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.updatePolicyNote) {
			if (res.data.updatePolicyNote.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.updatePolicyNote.errors })
		}
		return handleErrors(res)
	},

	async deleteNote(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.deleteNote,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.removePolicyNote) {
			if (res.data.removePolicyNote.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.removePolicyNote.errors })
		}
		return handleErrors(res)
	},

	async remove(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.remove,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.deletePolicy) {
			if (res.data.deletePolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.deletePolicy.errors })
		} else return handleErrors(res)
	},

	async deleteBeneficiaryEligibility(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.deleteBeneficiaryEligibility,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.removeBeneficiaryEligibility) {
			if (res.data.removeBeneficiaryEligibility.status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data.removeBeneficiaryEligibility.errors
				})
		}
		return handleErrors(res)
	},

	async cancelPolicy(variables) {
		let res = null

		try {
			res = await gql({
				query: mutation.cancelPolicy,
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.cancelPolicy) {
			if (res.data.cancelPolicy.status === "success")
				return Promise.resolve({ data: res.data })
			else return Promise.resolve({ errors: res.data.cancelPolicy.errors })
		} else return handleErrors(res)
	},

	async numberOfPolicies(variables) {
		let res = null

		try {
			res = await gql({
				query: query.numberOfPolicies(),
				variables
			})
		} catch (errors) {
			console.error(errors)
			return Promise.resolve(errorsFactory({ code: "general" }))
		}

		if (res && res.data && res.data.policies)
			return Promise.resolve({ data: res.data })
		else return handleErrors(res)
	},

	async sendCancellationEmail(variables) {
		const res = await gql({
			query: mutation.sendCancellationEmail,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	}
}
